module.exports = __webpack_public_path__ + "assets/img/submitBtn.12c84ccd.png";